import { React, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { Global } from '../../Global';

import '../../../assets/css/nuevoRegistro.css';

import Loading from '../../elementos/Loading';
import Error from '../../elementos/Error';
import HeaderVista from '../../elementos/HeaderVista';
import Input from '../../elementos/Input';
import CheckboxList from '../../elementos/CheckboxList';
import Snack from '../../elementos/Snack';

import LoginOutData from '../../helpers/LoginOutData';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import AccountCircle from '@mui/icons-material/AccountCircle';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PasswordIcon from '@mui/icons-material/Password';
import CheckIcon from '@mui/icons-material/Check';
import PercentIcon from '@mui/icons-material/Percent';



export default function UsuariosEditar() {

    const [estadoVista, setEstadoVista] = useState('cargado');
    const [snackOpen, setSnackOpen] = useState({ open: false, message: '', severity: 'error' });

    const [vendedores, setVendedores] = useState([]);
    const [permisosUsuarios, setPermisosUsuarios] = useState([]);

    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [tel_whatsapp, setTelWhatsapp] = useState('');
    const [comision, setComision] = useState('');
    const [contrasena1, setContrasena1] = useState('');
    const [contrasena2, setContrasena2] = useState('');
    const [permisos, setPermisos] = useState([]);
    const [acceso_vendedores, setAccesoVendedores] = useState([]);

    const navigate = useNavigate();
    const urlParams = useParams();

    const handleSubmit = (e) => {

        e.preventDefault();

        setEstadoVista('loading');

        let body = {
            nombre,
            email,
            tel_whatsapp,
            comision,
            permisos,
            acceso_vendedores,
            contrasena1,
            contrasena2,
        }

        axios.put(Global.url_api + 'usuarios/' + urlParams.id, body, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                axios.get(Global.url_api + 'self/refresh-token', { headers: { Authorization: localStorage.getItem("token") } })
                    .then(res => {

                        LoginOutData.LoginData(res);

                        navigate('/usuarios');

                    })
                    .catch((error) => {
                        setSnackOpen({
                            open: true,
                            message: (error?.response?.data ? error.response.data.message : 'Ocurrió un error.'),
                            severity: 'error'
                        })
                    });

            })
            .catch((error) => {
                //console.log(error?.response?.data);
                setSnackOpen({
                    open: true,
                    message: (error?.response?.data ? error.response.data.message : 'Ocurrió un error.'),
                    severity: 'error'
                })
                setEstadoVista('cargado');
            });

    }


    useEffect(() => {

        axios.get(Global.url_api + 'usuarios/' + urlParams.id, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                setNombre(res.data.nombre);
                setEmail(res.data.email);
                setTelWhatsapp(res.data.tel_whatsapp);
                setComision(res.data.comision);
                setPermisos(res.data.permisos);
                setAccesoVendedores(res.data.acceso_vendedores);

                axios.get(Global.url_api + 'usuarios/all', { headers: { Authorization: localStorage.getItem("token") } })
                    .then(res => {

                        setVendedores(res.data.usuarios);

                        axios.get(Global.url_api + 'permisos', { headers: { Authorization: localStorage.getItem("token") } })
                            .then(res => {

                                setPermisosUsuarios(res.data.permisos);
                                setEstadoVista('cargado');
                            })
                            .catch((error) => {
                                setEstadoVista('error');
                                setSnackOpen({
                                    open: true,
                                    message: (error?.response?.data ? error.response.data.message : 'Ocurrió un error.'),
                                    severity: 'error'
                                });
                            });

                    })
                    .catch((error) => {
                        console.log(error?.response?.data);
                        setEstadoVista('error')
                    });

            })
            .catch((error) => {
                console.log(error?.response?.data);
                setEstadoVista('error')
            });





    }, [urlParams]);


    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error />)

    if (estadoVista === 'cargado')
        return (
            <>
                <HeaderVista
                    volverTo="/usuarios"
                    titulo={"Editar Usuario / " + nombre}
                />
                <form onSubmit={handleSubmit}>
                    <Container className="nuevoRegistro" component="main" maxWidth="lg">
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Nombre"
                                    icon={<AccountCircle />}
                                    value={nombre}
                                    onChange={setNombre}
                                    type="text"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Email"
                                    icon={<MailOutlineIcon />}
                                    helperText="Será el usuario"
                                    value={email}
                                    onChange={setEmail}
                                    type="email"
                                    restricciones={['email']}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Whatsapp"
                                    icon={<WhatsAppIcon />}
                                    helperText="Ej 5491144445555"
                                    value={tel_whatsapp}
                                    onChange={setTelWhatsapp}
                                    type="tel"
                                    restricciones={['soloNumeros']}
                                    required
                                />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Comisión"
                                    icon={<PercentIcon />}
                                    helperText="Ej 0.1"
                                    value={comision}
                                    onChange={setComision}
                                    type="tel"
                                    restricciones={['soloNumerosDecimales']}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Contraseña"
                                    icon={<PasswordIcon />}
                                    helperText="Ingresa una contraseña"
                                    value={contrasena1}
                                    onChange={setContrasena1}
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <Input
                                    label="Repetir Contraseña"
                                    icon={<PasswordIcon />}
                                    helperText="Por favor repite la contraseña"
                                    value={contrasena2}
                                    onChange={setContrasena2}
                                    type="password"
                                />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} >
                                <CheckboxList
                                    titulo="Acceso Vendedores"
                                    opciones={vendedores.map(function (e) { return { codigo: e._id, nombre: e.nombre } })}
                                    elegidos={acceso_vendedores}
                                    handleChange={setAccesoVendedores}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <CheckboxList
                                    titulo="Permisos"
                                    opciones={permisosUsuarios}
                                    elegidos={permisos}
                                    handleChange={setPermisos}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                    <Container className="nuevoRegistro footer" component="main" maxWidth="lg">
                        <Grid container>
                            <Grid className="botones" item xs={12} >
                                <Button type="submit" variant="contained" color="success" startIcon={<CheckIcon />} >
                                    Guardar
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                    <Snack estado={snackOpen} setSnackOpen={setSnackOpen} />
                </form>
            </>
        )

}